class Person {
	constructor() {
		const toggler = Array.from( document.getElementsByClassName( 'modal-toggle' ) );
		const close = Array.from( document.getElementsByClassName( 'person__modal--close' ) );
		const modalOverlay = Array.from( document.getElementsByClassName( 'person__modal--overlay' ) );
		const modalWrap = Array.from( document.getElementsByClassName( 'person__modal--wrap' ) );

		const FOCUSABLE_SELECTORS = [
			'a[href]',
			'area[href]',
			'input:not([disabled])',
			'select:not([disabled])',
			'textarea:not([disabled])',
			'button:not([disabled])',
			'iframe',
			'object',
			'embed',
			'[tabindex]:not([tabindex="-1"])',
			'[contenteditable]',
		].join( ',' );

		let lastTrigger = null;
		let activeModal = null;
		let removeTrap = null;
		let handleEscape = null;

		function trapFocus( modal ) {
			const focusableEls = Array.from( modal.querySelectorAll( FOCUSABLE_SELECTORS ) );
			if ( focusableEls.length ) focusableEls[ 0 ].focus();
			function handleTab( e ) {
				if ( e.key !== 'Tab' ) return;
				if ( focusableEls.length === 0 ) return;
				const firstEl = focusableEls[ 0 ];
				const lastEl = focusableEls[ focusableEls.length - 1 ];
				if ( e.shiftKey ) {
					if ( document.activeElement === firstEl ) {
						e.preventDefault();
						lastEl.focus();
					}
				} else {
					if ( document.activeElement === lastEl ) {
						e.preventDefault();
						firstEl.focus();
					}
				}
			}
			modal.addEventListener( 'keydown', handleTab );
			return () => modal.removeEventListener( 'keydown', handleTab );
		}

		function openModal( modal, trigger ) {
			activeModal = modal;
			lastTrigger = trigger;
			modal.style.display = 'inline-block';
			modal.classList.add( 'is-visible' );
			removeTrap = trapFocus( modal );

			handleEscape = function ( ev ) {
				if ( ev.key === 'Escape' ) {
					closeModal( modal );
				}
			};
			document.addEventListener( 'keydown', handleEscape );
		}

		function closeModal( modal ) {
			modal.classList.remove( 'is-visible' );
			modal.style.display = 'none';
			if ( removeTrap ) removeTrap();
			document.removeEventListener( 'keydown', handleEscape );
			if ( lastTrigger ) lastTrigger.focus();
			activeModal = null;
			lastTrigger = null;
		}

		toggler.forEach( ( toggle ) => {
			toggle.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				const items = e.currentTarget.childNodes;
				Array.from( items ).forEach( ( item ) => {
					if ( item.className == 'person__modal' ) {
						openModal( item, e.currentTarget );
					}
				} );
			} );
		} );

		const handleClick = ( e ) => {
			e.preventDefault();
			const el = e.currentTarget.parentElement.parentElement.parentElement;
			if ( el.classList.contains( 'is-visible' ) ) {
				closeModal( el );
			}
		};

		const closeOverlay = ( e ) => {
			e.preventDefault();
			const el = e.currentTarget.parentElement;
			if ( el.classList.contains( 'is-visible' ) ) {
				closeModal( el );
			}
		};

		close.forEach( ( node ) => {
			node.addEventListener( 'click', handleClick );
		} );
		modalOverlay.forEach( ( node ) => {
			node.addEventListener( 'click', closeOverlay );
		} );
		modalWrap.forEach( ( node ) => {
			node.addEventListener( 'click', function ( event ) {
				event.stopPropagation();
			} );
		} );
	}
}

class Persons {
	constructor( node, opts = {} ) {
		this.node = node;
		this.persons = Array.from( this.node.querySelectorAll( '.person' ) ).map( ( node ) => new Person( node, opts ) );
	}
}

Persons.instances = Array.from( document.querySelectorAll( '.people' ) ).map( ( p ) => new Persons( p ) );
export default new Person();
